import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { ListTable } from 'gnos-tables'
import classnames from 'classnames'
import Tooltip, { POSITION } from 'gnos-tooltip'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import RadioButton from '../../../../../../../../../../../components/RadioButton'

import { LOCALE_PREFIX } from '../../constants'
import { ADDRESS_TYPES } from './constants'
import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Address extends Component {
    static propTypes = {
        addressesChangeActiveAddress: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        module: PropTypes.string.isRequired,
    }

    getColumnsDefinition = () => {
        const { intl, customData } = this.props

        return {
            visibleRows: ({ isNested }) => (isNested ? 0 : 10), // eslint-disable-line
            stepRows: 10,
            expandText: ({ isNested }) =>
                intl.formatMessage({ id: `${LOCALE_PREFIX}.${isNested ? 'history' : 'moreAddresses'}` }),
            columns: [
                {
                    accessor: 'value',
                    Cell: (value) => (
                        <span
                            className={classnames(
                                'addresses-cell',
                                _.get(value, 'original.historical') && 'historical'
                            )}
                        >
                            <div className={'ruianId-radio-btn-container'}>
                                {(_.get(value, 'original.ruianId') > 0 || value?.value) && (
                                    <RadioButton
                                        checked={_.get(customData, 'activeAddress.id') === _.get(value, 'original.id')}
                                        containerStyle={{ marginRight: '4px' }}
                                        options={_.get(value, 'original', {})}
                                        onClickHandler={(checked, options) =>
                                            this.handleRadioButtonClick(checked, options)
                                        }
                                    />
                                )}
                            </div>
                            <div
                                className={classnames(
                                    'address-pin',
                                    _.get(ADDRESS_TYPES, `${_.get(value, 'original.type')}`, 'default'),
                                    _.get(value, 'original.historical') && 'historical'
                                )}
                            />
                            <span className={'address-span'}>
                                {_.get(value, 'value', '')}
                                {_.get(value, 'original.riskyAddress', false) && (
                                    <Tooltip
                                        content={<FormattedMessage id={`${LOCALE_PREFIX}.riskyAddress`} />}
                                        id={`risky-address-tooltip-${_.get(value, 'original.ruianId')}`}
                                        width={'350px'}
                                        position={POSITION.TOP}
                                        automaticAlignChange
                                        doubleWrap
                                    >
                                        <div className={'risky-address'} />
                                    </Tooltip>
                                )}
                            </span>
                        </span>
                    ),
                },
                {
                    accessor: 'startDate',
                    width: 120,
                    Cell: (value) =>
                        _.get(value, 'value') && (
                            <span
                                className={classnames(
                                    'addresses-cell',
                                    _.get(value, 'original.historical') && 'historical'
                                )}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.date.from`} />
                                <CustomDate
                                    date={_.get(value, 'value.value', null)}
                                    precision={_.get(value, 'value.precision', null)}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        ),
                },
                {
                    accessor: 'endDate',
                    width: 120,
                    Cell: (value) =>
                        _.get(value, 'value') && (
                            <span
                                className={classnames(
                                    'addresses-cell',
                                    _.get(value, 'original.historical') && 'historical'
                                )}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.date.to`} />
                                <CustomDate
                                    date={_.get(value, 'value.value', null)}
                                    precision={_.get(value, 'value.precision', null)}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        ),
                },
            ],
        }
    }

    handleRadioButtonClick = (checked, options) => {
        const { addressesChangeActiveAddress, module, block, id, customData } = this.props

        addressesChangeActiveAddress(module, id, block, { ...customData, activeAddress: { ...options } })
    }

    render() {
        const { id, intl, data } = this.props

        const tableData = _.get(data, 'tables', {})

        return (
            <div className={'address-container'}>
                {tableData && (
                    <ListTable
                        id={`addresses-list-table-${id}`}
                        columnsDefinition={{
                            title: {
                                Cell: (value) => (
                                    <span
                                        className={'title-cell'}
                                        style={{ color: _.get(value, 'isNested', false) ? '#b2b2b2' : 'black' }}
                                    >
                                        {_.get(value, 'text', null)}
                                    </span>
                                ),
                                width: 340,
                            },
                            top: this.getColumnsDefinition(),
                            nested: this.getColumnsDefinition(),
                        }}
                        staticData={tableData}
                        texts={{
                            controlExpand: intl.formatMessage({ id: `${LOCALE_PREFIX}.moreAddresses` }),
                            controlMore: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlMore` }),
                            controlLess: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlLess` }),
                            controlAll: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlAll` }),
                            controlClose: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlClose` }),
                            controlFirst: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlFirst` }),
                        }}
                    />
                )}
            </div>
        )
    }
}
